<template> 
  <page-template>
    <template slot="page-content">
      <div class="db relative overflow-hidden home-handle-overflow">
        <div class="luxury-experiences--template page-template">
          <div class="relative container-fluid">
            <div class="db relative w-100 mw9 center pv4 z-content">
              <h1 class="f-page-title mv0 ttu is-blenny is-navy">{{ page.title }}</h1>
              <div class="row mt0 mt0-ns">
                <div class="col-xs-12 col-sm-6 ph0 mt4" v-for="(exp, index) in page.experiences" v-if="index < 2" :key="'luxury-experience-' + index">
                  <div class="relative" :class="{'bg-yellow': index == 0, 'bg-navy': index == 1}">
                    <h3 class="db mt2 pt4 ph4 tl ttu f-page-h3 is-blenny" :class="{'is-navy': index == 0, 'is-yellow f-ggc-title': index == 1}">{{ exp.title }}</h3>           
                    <span class="f5 db mt2 pb4 ph4 tl ttu is-lorano-bold is-yellow f-ggc-sub-title">{{ exp.sub_title }}</span>                             
                    <div class="db absolute w-100 horiz-line-beige"></div>                    
                    <img class="relative center img-responsive pa4" :src="exp.image" />
                    <div class="db absolute w-100 horiz-line-beige"></div>
                    <div class="relative pa4">
                      <div class="mt3 f4 cms-content" :class="{'is-navy': index == 0, 'is-yellow': index == 1}" v-html="marked(exp.text)"></div>
                      <a v-if="exp.button_cta.is_disabled" class="db mw6 mt4 btn-generic has-red-bg btn-disabled o-60" :title="exp.button_cta.copy"><span class="text">{{exp.button_cta.copy}}</span></a>
                      <a v-else-if="exp.button_cta.is_sold_out" class="db mw6 mt4 btn-generic has-red-bg btn-generic btn-disabled o-60" :title="exp.button_cta.copy"><span class="text">{{exp.button_cta.copy}}</span></a>
                      <a v-else class="db mw6 mt4 btn-generic has-red-bg link pointer" :href="exp.button_cta.link" :title="'Buy' + exp.title"><span class="text">{{exp.button_cta.copy}}</span></a>
                    </div>
                  </div>
                </div>
                <div class="dn db-ns absolute left-0 right-0 center vert-line-beige"></div>
              </div>
              <div class="db relative mt4">
                <div class="row" v-if="page.vip_vs_ggp.is_published">
                  <div class="col-xs-12 col-sm-12">
                    <!-- <h2 class="f-page-h2 is-blenny ttu is-navy">{{ page.vip_vs_ggp.title }}</h2> -->
                    <div class="db relative mt3">
                      <img class="db dn-ns relative w-100" v-lazy="page.vip_vs_ggp.mobile_image" :alt="page.vip_vs_ggp.title">
                      <img class="dn db-ns relative w-100" v-lazy="page.vip_vs_ggp.desktop_image" :alt="page.vip_vs_ggp.title">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt0 mt3-ns">
                <div class="col-xs-12 col-sm-6 ph0 mt4" v-for="(exp, index) in page.experiences" v-if="index > 1" :key="'luxury-experience-' + index">
                  <div class="relative" :class="{'bg-yellow': index == 2, 'bg-navy': index == 3}">
                    <h3 class="db f1 mt2 pa4 tl ttu f-page-h3 is-blenny" :class="{'is-navy': index == 2, 'is-yellow': index == 3}">{{ exp.title }}</h3>                    
                    <div class="db absolute w-100 horiz-line-beige"></div>      
                    <img class="relative center img-responsive pa4" :src="exp.image" />
                    <div class="db absolute w-100 horiz-line-beige"></div>
                    <div class="relative pa4">
                      <div class="mt3 f4 cms-content" :class="{'is-navy': index == 2, 'is-yellow': index == 3}" v-html="marked(exp.text)"></div>
                      <a v-if="exp.button_cta.is_disabled" class="db mw6 mt4 btn-generic has-red-bg btn-disabled o-60" :title="exp.button_cta.copy"><span class="text">{{exp.button_cta.copy}}</span></a>
                      <a v-else-if="exp.button_cta.is_sold_out" class="db mw6 mt4 btn-generic has-red-bg btn-generic btn-disabled o-60" :title="exp.button_cta.copy"><span class="text">{{exp.button_cta.copy}}</span></a>
                      <a v-else class="db mw6 mt4 btn-generic has-red-bg link pointer" :href="exp.button_cta.link" :title="'Buy' + exp.title"><span class="text">{{exp.button_cta.copy}}</span></a>
                    </div>
                  </div>
                </div>
                <div class="dn db-ns absolute left-0 right-0 center vert-line-beige"></div>
              </div>
              <div class="db relative mt4">
                <div class="row" v-if="page.cabanas_vs_box_suites.is_published">
                  <div class="col-xs-12 col-sm-12">
                    <!-- <h2 class="f-page-h2 is-blenny ttu is-navy">{{ page.cabanas_vs_box_suites.title }}</h2> -->
                    <div class="db relative mt3">
                      <img class="db dn-ns relative w-100" v-lazy="page.cabanas_vs_box_suites.mobile_image" :alt="page.cabanas_vs_box_suites.title">
                      <img class="dn db-ns relative w-100" v-lazy="page.cabanas_vs_box_suites.desktop_image" :alt="page.cabanas_vs_box_suites.title">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from './page-template.vue';
import PerksDropdown from './perks-dropdown.vue';
//var VueScrollTo = require('vue-scrollto');
export default {
  components: {
    PageTemplate,
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk ? `${titleChunk} | ` + this.$site_seo_title_suffix : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      //
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName('premium-experiences.markdown');
      return pageData[0];
    }
  },
  filters: {
    //
  },
  methods : {
    scrollMeTo(refName) {
      var el = this.$refs[refName][0];
      //var top = window.pageYOffset + el.getBoundingClientRect().top - 70;
      //window.scrollTo(0, top);
      var options = {
        container: '#container',
        easing: 'ease-in',
        offset: -70,
        force: true,
        cancelable: true,
        onStart: function(element) {
          //console.log('scrolling started');
        },
        onDone: function(element) {
          //console.log('scrolling is done');
        },
        onCancel: function() {
          //console.log('scrolling has been interrupted');
        },
        x: false,
        y: true
      }
      //var cancelScroll = VueScrollTo.scrollTo(el, 500, options)
    },
  },
  created() {
    window.addEventListener('scroll', this.scrollBg);
  },
  beforeMount() {
    //
  },
  mounted() {
    setInterval(() => {
      if(this.parallax2 !== false)
        this.parallax = this.parallax + 0.02;
    }), 10;
    if (this.$route.hash) {
      setTimeout(() => {
        var anchorId = this.$route.hash;
        var element = anchorId.replace('#','');
        document.getElementById(element).scrollIntoView();
      }, 300)
    }
    else {
      //console.log('else', this.$route.path );
    }
    this.$nextTick(() => {
      //
    })

  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollBg);
  }
}
</script>
